<template>
  <section class="section home">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="10" md="8">
          <div class='g-logos'>
              <a href="https://gskinner.com/" target="_blank" rel='noreferrer' aria-label="Open gskinner.com in a new tab">
                <img class='g-logos__gskinner' src="../assets/images/gskinner-logo-light.png" alt="gskinner" aria-hidden="true" />
              </a>
              <span class="g-divider--dark">x</span>
              <a href="https://www.adobe.com/ca/products/xd.html" target="_blank" rel="noreferrer" aria-label="Open adobe.com XD plugin in a new tab">
                <img class='g-logos__adobe' src="../assets/images/Adobe_Corporate_logo.svg" alt="adobe" aria-hidden="true" />
              </a>
          </div>
          <h1 aria-describedby="h1-desc" class="home__title heading-1">Export XD designs to Flutter</h1>
          <p id="h1-desc" class="home__description home__description--high-contrast body-1">
            The XD to Flutter plugin is a powerful, easy-to-use tool to export your
            stunning Adobe XD designs as reusable Flutter Widgets.
          </p>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="12">
          <div class="home__hero-image" aria-hidden="true">
            <img
              class="anim"
              src="../assets/images/screenshot-XD-flat.png"
              alt="Adobe XD project to be exported"
            />
            <img
              class="anim"
              src="../assets/images/screenshot-code-flat.png"
              alt="Visual Studio Code project with XD to Flutter plugin"
            />
            <img
              class="anim"
              src="../assets/images/screenshot-sim-flat.png"
              alt="XD project running in Flutter"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="10" md="8">
          <div class="home__actions">
            <a
              class="action action--fill"
              href="https://adobe.com/go/xd_to_flutter"
              target="_blank"
              rel="noreferrer"
              aria-label="Visit adobe.com to download XD to Flutter in a new tab"
            >
              Download
            </a>
            <a
              class="action action--border"
              href="https://github.com/AdobeXD/xd-to-flutter-plugin"
              target="_blank"
              rel="noreferrer"
              aria-label="Visit github.com to see the source code in a new tab"
            >
              Github
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "Home",
    data: () => ({
      heroElements: [],
      readyElements: 0,
    }),
    mounted() {
      this.heroElements = document.querySelectorAll("img.anim");

      this.heroElements.forEach(
        (el) =>
          (el.onload = () => {
            this.readyElements++;
            this.addLoadedClass();
          })
      );
    },
    methods: {
      addLoadedClass() {
        if (this.readyElements == this.heroElements.length) {
          this.heroElements.forEach((el) => el.classList.add("loaded"));
        }
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../variables";

  .anim {
    opacity: 0;
    transform: translateX(60px);
    @media (prefers-reduced-motion) {
      opacity: 1;
      transform: rotateY(10deg) translateX(0);
    }
    &.loaded {
      opacity: 1;
      transform: rotateY(10deg) translateX(0);
    }
  }

  .home {
    padding-top: pxToRem(40);
    text-align: center;
    position: relative;

    &.section {
      overflow: hidden;
    }

    .g-logos {
      display: inline;
      position: relative;
      z-index: 1;
      .g-divider {
        margin: 0 pxToRem(26);
        color: #2d2d2d;
        user-select: none;
        &--dark {
            @extend .g-divider;
            color: $white;
        }
      }
      &__gskinner {
          height: pxToRem(20);
          cursor: pointer;
      }
      &__adobe {
          height: pxToRem(20);
          margin-bottom: 0.15em;
          cursor: pointer;
      }
    }

    &__title {
      margin-bottom: 1rem;
      position: relative;
      z-index: 1;
      color: #ffffff;
      padding-top: pxToRem(68);
    }

    &__description {
      margin-bottom: pxToRem(59);
      position: relative;
      z-index: 1;
      &--high-contrast {
        color: #9AB9EF;
      }
    }

    &__hero-image {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: pxToRem(48);
      perspective: 1000px;

      &::before {
        content: "";
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
        background: $background;
        width: 100vw;
        height: 100vh;
        position: absolute;
        left: 50%;
        bottom: 10vw;
        transform: skewY(-7deg) translate(-50%, -1vw);
        z-index: -1;
      }

      img {
        position: relative;
        box-shadow: 0px 2px 10px 0px rgb(0 7 15 / 15%);
        transition: transform 1s cubic-bezier(0.33, 1, 0.68, 1),
          opacity 1s cubic-bezier(0.33, 1, 0.68, 1);
        @media (prefers-reduced-motion) {
          transform: none;
        }
        &:nth-child(1) {
          width: 60%;
          margin-left: 1.2rem;

          @media (min-width: 576px) {
            margin-left: 2rem;
          }

          @media (min-width: 768px) {
            margin-left: 3rem;
          }

          @media (min-width: 992px) {
            margin-left: 4.8rem;
          }
        }
        &:nth-child(2) {
          right: 20%;
          width: 37%;
          transition-delay: 250ms;
        }
        &:nth-child(3) {
          right: 24%;
          width: 17%;
          transition-delay: 500ms;
        }
      }
    }

    &__actions {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: pxToRem(96);
      .action {
        margin: pxToRem(8);
        text-decoration: none;
        &--fill {
          &:hover {
            color: #ffffff;
          }
        }
      }
    }
  }
</style>
